import { USA_STATE_LIST } from "../constant/constant";
import { formatOperatorAddress } from "./cpFieldRules";

export function cpDocumentFieldContext(data) {
  const role = data.document.role_key;
  const profile = data.context.signers[role];
  return {
    state_id: data.context.state_id,
    signing_date: data.context.signing_date,
    source_availability: data.context.signing_date === null ? { signing_date: "pending_signature" } : {},
    signers: { [role]: profile ? {
      name: profile.name, email: profile.email, phone: profile.phone, specialty: profile.specialty,
      address: role === "operator" ? formatOperatorAddress(profile.address_parts, [...USA_STATE_LIST, "Test (TE)"]) : "",
      source_availability: profile.source_availability,
      licenses: Array.isArray(profile.licenses) ? profile.licenses.map((license) => ({ ...license, state: license.state_id })) : null,
    } : null },
  };
}
